import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'morva-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.scss'],
})
export class SearchResultComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
